import { useMemo } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import getUserAuthorizationStatus from 'src/js/modules/user/selectors/user-authorization-status';
import getAvailableSubscriptionTypes from 'src/js/modules/partner/selectors/available-subscription-types';
import getTemplates from '../selectors/get-templates';
import filterAvailableTemplates from '../helpers/filter-available-templates';

const useTemplates = () => {
  const isUserAuthenticated = useSelector(getUserAuthorizationStatus);
  const availableSubscriptionTypes = useSelector(getAvailableSubscriptionTypes, shallowEqual);
  const templates = useSelector(getTemplates);

  const computedTemplates = useMemo(
    () => filterAvailableTemplates(templates, availableSubscriptionTypes, isUserAuthenticated),
    [templates, availableSubscriptionTypes, isUserAuthenticated]
  );

  return {
    templates: computedTemplates,
  };
};

export default useTemplates;
